import { Alert, Typography } from "@mui/material";
import { TableData, TableDataProps } from "../TableData";

export const BeroepsI1b2April15 = (props: TableDataProps) => {
  return (
    <>
      <TableData data={props.data} />

      <Alert severity="info" sx={{ alignItems: "center" }}>
        <Typography variant="h5">3e lesuur - opleveren 🏆</Typography>
      </Alert>

      <Alert severity="error" sx={{ mb: 2, alignItems: "center" }}>
        <Typography variant="h5">
          4e lesuur - werken aan werkprocessen - Let op, uiterlijk 00:00
          inleveren!
        </Typography>
      </Alert>
    </>
  );
};
